export enum Role {
  ADMIN = "tak_messaging_admin",
  USER = "tak_messaging_user"
}
